import { connect } from 'react-redux';
import { selectors as newOutputSelectors } from 'ducks/documentOutput';
import DocOutputField from './DocOutputField';

const mapStateToProps = (state, ownProps) => ({
    fieldValue: newOutputSelectors.fieldValue(ownProps.documentType, ownProps.fieldId)(state),
});

export default connect(mapStateToProps)(DocOutputField);
